import React from 'react';
import { SlidersHorizontal, CheckSquare, Trash2, ZoomInIcon, Menu, X, BarChart2, RefreshCcw } from 'lucide-react';

const Toolbar = ({ slideInfo, isSidebarOpen, onToggleSidebar, onTogglePlot, scale, lassoProps, onResetView, onToggleInfo, onToggleControls }) => {
  const { isLassoMode, lassoPoints, setLassoPoints, isDrawingLasso, annotationName, setAnnotationName, handleSaveAnnotation, cropping } = lassoProps;

  return (
    <div className="bg-white dark:bg-slate-800 shadow-sm border-b dark:border-gray-700 px-2 md:px-4 py-2 flex items-center justify-between gap-4 flex-shrink-0 z-40">
      <div className="flex flex-1 items-center gap-2 min-w-0">
        <button onClick={onToggleSidebar} className="p-2 rounded-md hover:bg-gray-200 dark:hover:bg-gray-600">
          {isSidebarOpen ?  <X size={20} /> : <Menu size={20} />}
        </button>
        <h1 onClick={onToggleInfo} className="text-sm md:text-lg font-semibold text-gray-800 dark:text-gray-200 truncate cursor-pointer" title={slideInfo ? slideInfo.name : "Histology Viewer"}>
          {slideInfo ? slideInfo.name : "Histology Viewer"}
        </h1>
      </div>

      <div className="flex items-center space-x-1 md:space-x-2">
        {slideInfo && (
          <div className="hidden md:flex items-center space-x-2 border-r dark:border-gray-600 text-stone-600 dark:text-stone-400 pr-2 mr-2">
            <ZoomInIcon size={16} title="Zoom level" /><span>{(scale * 100).toFixed(2)}%</span>
            {isLassoMode && lassoPoints.length > 0 && !isDrawingLasso && (
              <>
                <input type="text" value={annotationName} onChange={(e) => setAnnotationName(e.target.value)} placeholder="Annotation name..." className="px-2 py-1 border rounded-md text-sm bg-white dark:bg-gray-800 border-gray-300 dark:border-gray-600" />
                <button onClick={handleSaveAnnotation} disabled={cropping} className="px-3 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600 flex items-center space-x-2 disabled:bg-gray-400" title="Save Annotation">
                  <CheckSquare size={16} /> <span>{cropping ? 'Saving...' : 'Save'}</span>
                </button>
                <button onClick={() => setLassoPoints([])} className="p-2 bg-red-500 text-white rounded-lg hover:bg-red-600" title="Clear Selection">
                  <Trash2 size={16} />
                </button>
              </>
            )}
          </div>
        )}
        <div className="flex items-center space-x-1 md:space-x-2">
          { (
            <>

                <button onClick={onTogglePlot} className="lg:hidden p-2 bg-gray-200 dark:bg-gray-600 dark:hover:bg-gray-500 rounded-lg hover:bg-gray-300 transition-colors" title="Show Plot">
                  <BarChart2 size={16} />
                </button>
              <button onClick={onToggleControls} className="p-2 bg-gray-200 dark:bg-gray-600 dark:hover:bg-gray-500 rounded-lg hover:bg-gray-300 transition-colors" title="Show Info">
                <SlidersHorizontal size={16} />
              </button>
              <button onClick={onResetView} className="p-2 md:px-3 md:py-2 bg-gray-200 dark:bg-gray-600 dark:hover:bg-gray-500 rounded-lg hover:bg-gray-300 transition-colors" title="Reset View">
                 <RefreshCcw size={16} />
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};


export default Toolbar;